import React, { useEffect, useState } from "react";
import axios from "../../services/api";

const Reports = () => {
  const [reportType, setReportType] = useState("purchase-order");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [branches, setBranches] = useState([]);
  const [fromBranchId, setFromBranchId] = useState("");
  const [toBranchId, setToBranchId] = useState("");

  useEffect(() => {
    axios.get("/stock/transfer-branches")
      .then((response) => setBranches(response.data || []))
      .catch(() => setBranches([]));
  }, []);

  const handleGeneratePDF = async () => {
    if (!fromDate || !toDate) {
      alert("Please select both from and to dates.");
      return;
    }

    const params = new URLSearchParams({ from: fromDate, to: toDate });
    if (reportType === "stock-transfer") {
      if (fromBranchId) params.set("from_branch_id", fromBranchId);
      if (toBranchId) params.set("to_branch_id", toBranchId);
    }
    const query = params.toString();

    if (reportType === "stock-transfer") {
      try {
        const response = await axios.get(`/reports/stock-transfer/pdf?${query}`, { responseType: "blob" });
        const blobUrl = URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
        window.open(blobUrl, "_blank");
        setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
      } catch (error) {
        alert(error.response?.data?.error || "Failed to generate Stock Transfer report.");
      }
      return;
    }

    // Existing reports continue using their current direct PDF URLs.
    const url = `${window.location.origin}/api/reports/${reportType}/pdf?${query}`;

    console.log("Opening report URL:", url);

    window.open(url, "_blank");
  };

  return (
    <div className="container">
      <h4>Generate Reports</h4>

      <div className="row g-3 mb-4">
        <div className="col-md-3">
          <label>Report Type</label>
          <select
            className="form-select"
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
          >
            <option value="purchase-order">Purchase Order</option>
            <option value="requisition">Requisition</option>
            <option value="grn">GRN</option>
            <option value="return-requisition">Return Requisition</option>
            <option value="stock-adjustment">Stock Adjustment</option>
            <option value="stock-transfer">Stock Transfer (Branch to Branch)</option>
          </select>
        </div>

        <div className="col-md-3">
          <label>From Date</label>
          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div className="col-md-3">
          <label>To Date</label>
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div className="col-md-3 d-flex align-items-end">
          <button className="btn btn-primary w-100" onClick={handleGeneratePDF}>
            Generate PDF
          </button>
        </div>
      </div>

      {reportType === "stock-transfer" && (
        <div className="row g-3 mb-4">
          <div className="col-md-4">
            <label>From Branch (optional)</label>
            <select className="form-select" value={fromBranchId} onChange={(e) => setFromBranchId(e.target.value)}>
              <option value="">All source branches</option>
              {branches.map((branch) => <option key={branch.id} value={branch.id}>{branch.name}</option>)}
            </select>
          </div>
          <div className="col-md-4">
            <label>To Branch (optional)</label>
            <select className="form-select" value={toBranchId} onChange={(e) => setToBranchId(e.target.value)}>
              <option value="">All destination branches</option>
              {branches.filter((branch) => String(branch.id) !== String(fromBranchId)).map((branch) => (
                <option key={branch.id} value={branch.id}>{branch.name}</option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reports;
